import { Controller } from "@hotwired/stimulus"

// The landing demo video autoplays muted in a loop. Users who prefer
// reduced motion get a paused player with controls instead.
export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.removeAttribute("autoplay")
      this.element.setAttribute("controls", "")
      this.element.pause()
    }
  }
}
